export default "__VITE_ASSET__CXcMGALk__"